import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat } from 'lodash';
import React, { FC } from 'react';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getProjektLaufzeitBIS_Validation,
	getProjektLaufzeitVON_Validation,
} from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { GetCompareMinMaxEqualDate, NonRequired } from '../../../../../../../lib/validation/ValidationTypes';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import { get } from 'lodash';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import { formStrucProjektdatenPruefassistentGlobal } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import Schema from '../../../../../../../lib/paths/antrag_FULL_Paths.json';
let P = Schema.attributes;

const ProjektDatenAntragKreativwirtschaft: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Allgemein_Pruefung_Pruefstatus.path}
				hinweisPath={P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Allgemein_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Allgemein_Pruefung_Erledigt.path}
				formStruc={formStrucProjektdatenPruefassistentGlobal(application)}
			/>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucProjektdaten()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucProjektdaten2(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};
export default ProjektDatenAntragKreativwirtschaft;

const formStrucProjektdaten = (): FormStrucItem[] => [
	{
		fields: [P.Allgemein_Projekttitel, { ...P.Allgemein_Kurzwort, maxCharLength: 12 }],
		userProps: { direction: 'column', columnToDivide: 1 },
	},
];

//TODO richtige itaros values anpassen
const formStrucProjektdaten2 = (application: any) => {
	const projektlaufzeitVon = get(application, P.Allgemein_Geplante_Projektlaufzeit_von.path);
	const projektlaufzeitBis = get(application, P.Allgemein_Geplante_Projektlaufzeit_bis.path);

	const tagDesEventsVon = get(
		application,
		P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0122590990_Bzw_Zeitraum_Des_Events_von.path,
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Allgemein_Geplante_Projektlaufzeit_von,
					...getProjektLaufzeitVON_Validation(application),
				},
				{
					...P.Allgemein_Geplante_Projektlaufzeit_bis,
					...getProjektLaufzeitBIS_Validation(application),
				},
			],
		},
		{
			fields: [
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0122590990_Bzw_Zeitraum_Des_Events_von,
					validation: [
						{ validateFunction: NonRequired, onlyValidateOnNonEmptyValue: true },
						{
							validateFunction: GetCompareMinMaxEqualDate,
							onlyValidateOnNonEmptyValue: true,
							params: [projektlaufzeitVon, projektlaufzeitBis],
						},
					],
				},
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0122594131_Bzw_Zeitraum_Des_Events_bis,
					validation: [
						{ validateFunction: NonRequired, onlyValidateOnNonEmptyValue: true },
						{ validateFunction: GetCompareMinMaxEqualDate, onlyValidateOnNonEmptyValue: true, params: [tagDesEventsVon, projektlaufzeitBis] },
					],
				},
			],
		},
		{
			fields: [],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucProjektDatenAntragKreativwirtschaft = (application: any) => {
	let result: FormStrucItem[] = [];
	result = concat(formStrucProjektdaten(), formStrucProjektdaten2(application));

	if (
		checkIfPruefAssitenzNeedsToValidate(application, P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path, P.Allgemein_Pruefung_Erledigt.path)
	) {
		result = concat(formStrucProjektdatenPruefassistentGlobal(application), result);
	}
	return result;
};
